import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import AuthPage from "@/pages/AuthPage";
import Shell from "@/pages/Shell";
import InstallPrompt from "@/components/InstallPrompt";
import SplashScreen from "@/components/SplashScreen";
import { Loader2 } from "lucide-react";

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
}

// Retour d'Emergent Google Auth : échange le session_id contre nos cookies JWT.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AuthCallback() {
  const hasProcessed = useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        if (sid) await api.post("/auth/google/session", { session_id: sid });
      } catch {
        /* on retombe sur la page de login si échec */
      }
      window.location.replace(window.location.origin + "/");
    })();
  }, []);
  return <Spinner />;
}

function Gate() {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  return user ? <Shell /> : <Navigate to="/login" replace />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  return user ? <Navigate to="/" replace /> : <AuthPage />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/*" element={<Gate />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <SplashScreen />
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <AppRouter />
          <InstallPrompt />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
